// removed by extract-text-webpack-plugin
module.exports = {"label":"style__label___14gON","checkbox":"style__checkbox___BBTO-"};


//////////////////
// WEBPACK FOOTER
// ./components/RadioOption/style.scss
// module id = 1231
// module chunks = 0